export default __webpack_public_path__ + "static/media/2901.24375ae0.png";